import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex flex-row w-full justify-end mb-3" }
const _hoisted_2 = { class: "bg-white mx-auto mb-8" }
const _hoisted_3 = { class: "text-white mb-6 p-3 rounded-lg bg-blue-600 w-full font-semibold" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "bg-blue-200 text-white text-xs font-semibold px-5 py-1 rounded-full me-4" }
const _hoisted_10 = { class: "flex justify-between items-center w-full mb-6" }
const _hoisted_11 = {
  for: "class-filter",
  class: "block text-sm font-medium text-gray-700 mb-1"
}
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "min-w-full w-full" }
const _hoisted_15 = { class: "columns" }
const _hoisted_16 = { class: "border-y border-y-gray-200 border-l border-l-gray-200 py-3 text-gray-600 font-medium text-xs text-start pl-6" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start" }
const _hoisted_22 = { class: "border-y border-y-gray-200 border-r border-r-gray-200 py-3 text-gray-600 font-medium text-xs text-start pr-6" }
const _hoisted_23 = { class: "border-y border-y-gray-200 border-r border-r-gray-200 py-3 text-gray-600 font-medium text-xs text-start pr-6 hidden" }
const _hoisted_24 = { class: "text-gray-900 text-sm font-medium py-6 border-b border-b-gray-200 pl-6 border-l border-l-gray-200" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_27 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_28 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_29 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_30 = { class: "flex justify-start items-center gap-2" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200 pr-6 border-r border-r-gray-200" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200 pr-6 border-r border-r-gray-200 hidden" }, /*#__PURE__*/_toDisplayString("******"), -1)
const _hoisted_34 = { class: "pagination w-full text-center my-8 flex items-center space-x-1 justify-center" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex item-center justify-between mt-6" }
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = { class: "relative px-4 pb-4 pt-5" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-center sm:mt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-medium leading-6 text-gray-900" }, "Do you have an email address for all of the learners in this class?"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, " If not, we will autogenerate an email address for them to login with the following structure: "),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-sm text-gray-600" }, " Iname.surname@schoolname.co.za ")
  ])
], -1)
const _hoisted_40 = { class: "mt-5 sm:mt-6 flex items-center justify-center gap-x-4" }
const _hoisted_41 = { class: "relative px-4 pb-4 pt-5" }
const _hoisted_42 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_43 = { class: "text-lg font-semibold leading-6 text-gray-900" }
const _hoisted_44 = { class: "relative px-4 pb-4 pt-5" }
const _hoisted_45 = { class: "mt-6 text-center" }
const _hoisted_46 = { class: "flex justify-between mb-6" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold leading-6 text-gray-900" }, "Bulk upload new students to [class]", -1)
const _hoisted_48 = { class: "flex items-center" }
const _hoisted_49 = { class: "space-y-5" }
const _hoisted_50 = { class: "mb-4 flex items-center justify-between text-sm" }
const _hoisted_51 = { class: "font-semibold" }
const _hoisted_52 = { class: "w-full bg-gray-200 rounded-full h-2 dark:bg-gray-700" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-4" }, null, -1)
const _hoisted_54 = { class: "w-full max-h-[30rem] overflow-y-scroll" }
const _hoisted_55 = { class: "table-auto w-full divide-y divide-gray-300" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "rounded-lg" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 text-start text-xs font-semibold text-gray-600" }),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 py-3.5 text-start text-xs font-semibold text-gray-600" }, " Email "),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 py-3.5 text-start text-xs font-semibold text-gray-600" }, " First name "),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 py-3.5 text-start text-xs font-semibold text-gray-600" }, " Last name "),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 py-3.5 text-start text-xs font-semibold text-gray-600" }, " Student number "),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 text-start text-xs font-semibold text-gray-600" }, " Password ")
  ])
], -1)
const _hoisted_57 = { class: "divide-y divide-gray-200" }
const _hoisted_58 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_59 = { class: "py-1 pr-4 text-gray-500 text-sm font-medium text-start" }
const _hoisted_60 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_61 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_62 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_63 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_64 = { class: "mt-5 sm:mt-6 flex items-center justify-end gap-x-4" }
const _hoisted_65 = { class: "p-8 relative" }
const _hoisted_66 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_67 = { class: "relative" }
const _hoisted_68 = {
  key: 0,
  class: "absolute bottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2"
}
const _hoisted_69 = { class: "mt-6 text-center" }
const _hoisted_70 = { class: "text-2xl font-semibold leading-6 text-gray-600" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500 mb-8" }, " Email with further steps will be sent to school admin and teacher. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 mb-8" }, " Upload will be processed, do you want to select any more existing students? ")
], -1)
const _hoisted_72 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "text-indigo-300 rounded-full border border-indigo-300 px-8 py-2 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap"
}, " Class complete ", -1)
const _hoisted_74 = { class: "p-8 relative" }
const _hoisted_75 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_76 = { class: "mt-6 text-center" }
const _hoisted_77 = { class: "text-2xl font-semibold leading-6 text-gray-900" }
const _hoisted_78 = { class: "mt-4 text-center" }
const _hoisted_79 = { class: "text-sm text-gray-600" }
const _hoisted_80 = { class: "text-gray-600" }
const _hoisted_81 = { class: "mt-6 flex justify-around items-center" }

import { FormKitNode } from "@formkit/core";
import { useLearnerStore } from "@/stores/learnerStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLicenseStore } from "@/stores/licenseStore";
import { useNoticeStore } from "@/stores/noticeStore";
import { useFilterStore } from "@/stores/filterStore";
import { ref, watch, computed, onBeforeMount } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useRolloverStore } from "@/stores/rolloverStore";
import { Rollover } from "@/interfaces/rollover.interface";
import { find, union } from "lodash";
import {
  UserIcon,
  TrashIcon,
  VideoCameraIcon
} from "@heroicons/vue/24/outline";
import FileUploadWidgetComponent from "../components/FileUploadWidgetComponent.vue";
import TutorialModalComponent from "../components/TutorialModalComponent.vue";
import { Subject } from "@/interfaces/subject.interface";

const learnersPerPage = 8;
const maxVisiblePages = 6;
type LearnerSortableKey = 'firstName' | 'lastName' | 'email' | 'studentNumber';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddStudentToClassView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const shouldGenerateEmail = ref(false);
const showFileUploadModal = ref(false);
const showGenerateEmailModal = ref(false);
const showUploadedLearnersModal = ref(false);
const showLearnersBulkUploadProgressModal = ref(false);
const bulkUploadLoading = ref(false);
const confirmAssignLearnersModal = ref(false);
const showModal = ref(false);
const gradeLevel = ref<number>(0);
const currentClassGroup = ref<any>(null);
// previous classes filter
const selectedClassFilter = ref("");
const searchQuery = ref("");
const currentPage = ref(1);
const selectedLearners = ref<string[]>([]);
const uploadedLearners = ref<any>([]);
const sortKey = ref<LearnerSortableKey | null>(null) as any;
const sortOrder = ref<'asc' | 'desc'>('asc');

// Data Sources
const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();
const noticeStore = useNoticeStore();
const filterStore = useFilterStore();
const rolloverStore = useRolloverStore();
const licenseStore = useLicenseStore();

onBeforeMount(async () => {
  await noticeStore.fetchNotices(filterStore.selectedFilters.school as string);
  await licenseStore.fetchLicenses(
    filterStore.selectedFilters.school as string
  );

  if (licenseStore.license) {
    const payload = {
      school: filterStore.selectedFilters.school,
      license: licenseStore.license._id,
      status: "pending",
    };

    await licenseStore.fetchLicenseRequests(payload);
  }
});

const learners = computed(() => {
  return learnerStore.getSchoolLearners.filter((learner) => {
    return (
      learner.status === "active" &&
      learner.grade === gradeLevel.value
    );
  });
});

const licenseProgress = computed(
  () => (product: any) =>
    Math.round((product.seatsUsed / product.maxSeats) * 100)
);

const fetchPreviousClasses = async () => {
  const currentSchool = schoolStore.getCurrentSchool;
  if (currentSchool) {
    // await rolloverStore.fetchSchoolRollover(currentSchool._id);
  }

  return;
};

// Generate unique previous classes for the dropdown
const uniquePreviousClasses = computed(() => {
  // Ensure we're mapping over all learners with previous classes
  const allClasses = learnersWithPreviousClasses.value.flatMap((learner) =>
    learner.previousClasses.map((classDetails: any) => classDetails.name)
  );
  return [...new Set(allClasses)]; // Use Set to deduplicate
});

const classList = computed(() =>
  schoolStore?.currentSchoolStructure?.classGroups.map((classGroup) => ({
    name: classGroup.name,
    _id: classGroup._id,
    subject: classGroup.subject
  }))
);

// Create a lookup map for class IDs to names
const classMap = computed(() => {
  return (classList.value ?? []).reduce((map: Record<string, string>, classGroup) => {
    map[classGroup._id] = classGroup.name;
    return map;
  }, {} as Record<string, string>);
});

const learnersWithPreviousClasses = computed(() => {
  // Map previous classes for each learner
  const previousClassesMap = rolloverStore?.getRollover?.learnerPreviousClasses.reduce(
    (acc: Record<string, any>, curr: any) => {
      acc[curr.learner] = curr.previousClasses;
      return acc;
    },
    {} as Record<string, any>
  );

  const schoolClasses = filterStore.selectedSchool.classes;

  // Combine learner data with their previous classes' details
  return learners.value
    .map((learner) => ({
      ...learner,
      previousClasses: (previousClassesMap?.[learner._id] || []).map(
        (classDetails: any) => ({
          id: classDetails,
          name: classMap.value[classDetails._id] || "Unknown Class",
          subjectName: classDetails?.subject?.name || "Unknown Subject",
        })
      ),
    }))
    .filter((learner) => {
      // Check if the learner is already assigned to the current class
      const isAssignedToCurrentClass = rolloverStore?.getRollover?.learnerAssignmentActions.some(
        (assignment) => assignment.learner === learner._id && assignment.newClassGroups.includes(currentClassGroup.value._id)
      );

      // Check if the learner is assigned to a class with the same subject
      const isAssignedToSameSubject = rolloverStore?.getRollover?.learnerAssignmentActions.some(
        (assignment) => assignment.learner === learner._id && assignment.newClassGroups.some(
          (classGroupId) => {
            const classGroup = schoolClasses.find(group => group._id === classGroupId);
            return classGroup && classGroup.subject === currentClassGroup.value.subject;
          }
        )
      );

      return isAssignedToCurrentClass || !isAssignedToSameSubject;
    });
});

const filteredLearners = computed(() => {
  const query = searchQuery.value.toLowerCase();
  return learnersWithPreviousClasses.value.filter((learner) => {
    const matchesSearchQuery =
      learner.email.toLowerCase().includes(query) ||
      learner.lastName.toLowerCase().includes(query) ||
      learner.firstName.toLowerCase().includes(query) ||
      learner.studentNumber.toLowerCase().includes(query);

    const matchesClassFilter =
      !selectedClassFilter.value ||
      learner.previousClasses.some(
        (classDetails: any) => classDetails.name === selectedClassFilter.value
      );

    return matchesSearchQuery && matchesClassFilter;
  });
});

watch(searchQuery, () => {
  currentPage.value = 1;
});

const filteredAndPaginatedLearners = computed(() => {
  const start = (currentPage.value - 1) * learnersPerPage;
  return filteredLearners.value.slice(start, start + learnersPerPage);
});

const selectedClass = currentClassGroup;

// Filter learners dynamically based on selected class
let filteredLearnersClasses = computed(() => {
  if (!selectedClass) {
    return filteredAndPaginatedLearners.value;
  }

  return filteredAndPaginatedLearners.value.filter((learner) => {
    const alreadyAssignedRollover = rolloverStore?.getRollover?.learnerAssignmentActions.some((assignment) => {
      return (
        assignment.learner === learner._id &&
        assignment.newClassGroups.some((cls) => {
          return cls == selectedClass._id
        })
      );
    });

    // console.log("Already Assigned:", alreadyAssigned);
    return !alreadyAssignedRollover;
  });
});

watch(
  filteredLearnersClasses,
  (newVal, oldVal) => {
    // console.log("Filtered learners updated:", newVal);
  },
  { deep: true }
);

const visiblePages = computed(() => {
  let start = Math.max(currentPage.value - Math.floor(maxVisiblePages / 2), 1);
  let end = Math.min(start + maxVisiblePages - 1, totalPages.value);

  // Adjust the start and end if we are at the end of the page range
  if (end >= totalPages.value) {
    start = Math.max(totalPages.value - maxVisiblePages + 1, 1);
  }

  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
});

const totalPages = computed(() =>
  Math.ceil(filteredLearners.value.length / learnersPerPage)
);

const goToPage = (pageNumber: any) => {
  currentPage.value = pageNumber;
};

const receiveUploadedLearners = (learners: any) => {
  showUploadedLearnersModal.value = true;
  uploadedLearners.value = learners;
};

const clearLearners = () => {
  uploadedLearners.value = [];
  showUploadedLearnersModal.value = false;
};

const submitLearnersForUpload = async () => {
  showUploadedLearnersModal.value = false;
  showLearnersBulkUploadProgressModal.value = true;

  try {
    bulkUploadLoading.value = true;

    await learnerStore.bulkCreateLearners(uploadedLearners.value);

    uploadedLearners.value = [];
    bulkUploadLoading.value = false;
  } catch (error) {
    console.error(error);
  } finally {
    bulkUploadLoading.value = false;
  }
};

const showConfirmation = () => {
  confirmAssignLearnersModal.value = true;
};

let alreadyAssigendLearners = ref<any>([]);

const assignLearners = async () => {
  const currentRollObject = rolloverStore.rollover as Rollover;

  selectedLearners.value.forEach((learnerId) => {
    const learnerExistingAssignmentAction = find(
      currentRollObject.learnerAssignmentActions,
      { learner: learnerId }
    );

    if (learnerExistingAssignmentAction) {
      learnerExistingAssignmentAction.newClassGroups = union(
        learnerExistingAssignmentAction.newClassGroups,
        [currentClassGroup.value._id]
      );
    } else {
      currentRollObject.learnerAssignmentActions.push({
        learner: learnerId,
        newClassGroups: [currentClassGroup.value._id],
      });
    }
  });

  currentRollObject.learnerAssignmentActions = currentRollObject.learnerAssignmentActions.filter(
    (assignment) => {
      if (assignment.newClassGroups.includes(currentClassGroup.value._id)) {
        if (!selectedLearners.value.includes(assignment.learner)) {
          assignment.newClassGroups = assignment.newClassGroups.filter(
            (classGroupId) => classGroupId !== currentClassGroup.value._id
          );
        }
      }
      return assignment.newClassGroups.length > 0;
    }
  );

  alreadyAssigendLearners.value = selectedLearners.value;

  // addLearnerToClass

  await rolloverStore.updateRolloverObject(currentRollObject);

  confirmAssignLearnersModal.value = false;

  // go to /main/add-students
  router.push("/main/add-student");
};

// Method to check if all learners are selected
const areAllSelected = computed(() => {
  const start = (currentPage.value - 1) * learnersPerPage;
  const end = start + learnersPerPage;
  const currentPageLearnersIds = filteredLearners.value
    .slice(start, end)
    .map((learner) => learner._id);
  return currentPageLearnersIds.every((id) =>
    selectedLearners.value.includes(id)
  );
});

// Method to toggle all learners on the current page
const toggleAll = () => {
  const start = (currentPage.value - 1) * learnersPerPage;
  const end = start + learnersPerPage;
  const currentPageLearners = filteredLearners.value.slice(start, end);

  if (areAllSelected.value) {
    // If all are selected, remove them from selectedLearners
    currentPageLearners.forEach((learner) => {
      const index = selectedLearners.value.indexOf(learner._id);
      if (index !== -1) selectedLearners.value.splice(index, 1);
    });
  } else {
    // If not all are selected, add them to selectedLearners
    currentPageLearners.forEach((learner) => {
      if (!selectedLearners.value.includes(learner._id)) {
        selectedLearners.value.push(learner._id);
      }
    });
  }
};

onBeforeMount(async () => {
  await fetchPreviousClasses();
  const classGroupId = route.params.classId;

  currentClassGroup.value =
    schoolStore.currentSchoolStructure?.classGroups.find(
      (classGroup) => classGroup._id === classGroupId
    );

  gradeLevel.value = currentClassGroup.value?.gradeLevel;

  const learners = learnerStore.getLearnersByGrade(currentClassGroup.value?.gradeLevel ?? 0);

  if (learners.length > 0) {
    for (const learner of learners) {
      rolloverStore.addLearnerToLearnerAssignmentActions(learner);
    }

    // Update the rollover object
    // await rolloverStore.updateRolloverObject(rolloverStore.rollover as Rollover);
  }

  const currentRollover = rolloverStore.rollover as Rollover;

  const alreadSelectedLearners = currentRollover.learnerAssignmentActions
    .filter((action) =>
      action.newClassGroups.includes(currentClassGroup.value._id)
    )
    .map((action) => action.learner);

  selectedLearners.value = alreadSelectedLearners;
});

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    // Call the validateEmail action with the node's value
    const emailExists = await learnerStore.validateEmail(node.value as string);
    return !emailExists;
  } catch (error) {
    return true;
  }
};

const sortBy = (key: string) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortOrder.value = 'asc';
  }
};

const sortedLearners = computed(() => {
  if (!sortKey.value) return filteredLearnersClasses.value;
  return [...filteredLearnersClasses.value].sort((a, b) => {
    if (!sortKey.value) return 0;
    const aValue = a[sortKey.value as LearnerSortableKey] ?? '';
    const bValue = b[sortKey.value as LearnerSortableKey] ?? '';
    const result = String(aValue).localeCompare(String(bValue));
    return sortOrder.value === 'asc' ? result : -result;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_modal = _resolveComponent("modal")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg flex flex-row items-center gap-1.5",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
        }, [
          _createVNode(_unref(VideoCameraIcon), {
            class: "-ml-0.5 h-5 w-5",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("global.tutorial")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _createTextVNode("Class: " + _toDisplayString(currentClassGroup.value?.name) + " - ", 1),
              (currentClassGroup.value?.subject === '6572e09f4af560ef2589e5ba')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "M"))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "E"))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString(selectedLearners.value.length) + " " + _toDisplayString(_ctx.$t("archive_flow.selected")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "search",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
              placeholder: "Search...",
              class: "rounded-md border-0 bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 px-4 py-2 w-1/2"
            }, null, 512), [
              [_vModelText, searchQuery.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.previous_class_label")) + ": ", 1),
              _withDirectives(_createElementVNode("select", {
                id: "class-filter",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedClassFilter).value = $event)),
                class: "text-gray-700 text-semibold py-2.5 px-4 rounded-lg flex gap-1 border border-gray-300 w-full"
              }, [
                _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.all_classes_text")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniquePreviousClasses.value, (className) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: className,
                    value: className
                  }, _toDisplayString(className), 9, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedClassFilter.value]
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_14, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_15, [
                _createElementVNode("th", _hoisted_16, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    onChange: toggleAll,
                    checked: areAllSelected.value,
                    class: "h-4 w-4 border border-blue-600 text-blue-600 focus:ring-blue-600"
                  }, null, 40, _hoisted_17)
                ]),
                _createElementVNode("th", {
                  class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (sortBy('firstName')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.first_name")) + " ", 1),
                  (sortKey.value === 'firstName' || sortKey.value === null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(sortOrder.value === 'asc' ? '▲' : '▼'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (sortBy('lastName')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")) + " ", 1),
                  (sortKey.value === 'lastName' || sortKey.value === null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(sortOrder.value === 'asc' ? '▲' : '▼'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (sortBy('email')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.email")) + " ", 1),
                  (sortKey.value === 'email' || sortKey.value === null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(sortOrder.value === 'asc' ? '▲' : '▼'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.previous_class")), 1),
                _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t("archive_flow.learners_table.student_number")), 1),
                _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t("archive_flow.learners_table.password")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedLearners.value, (learner, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: _normalizeClass([{
              'selected-row': selectedLearners.value.includes(learner._id),
            }, "mb-1"])
                }, [
                  _createElementVNode("td", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: learner._id,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedLearners).value = $event)),
                      class: "h-4 w-4 border border-blue-600"
                    }, null, 8, _hoisted_25), [
                      [_vModelCheckbox, selectedLearners.value]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(learner.firstName), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(learner.lastName), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(learner.email), 1),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("ul", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learner.previousClasses, (classDetails, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: classDetails.id._id
                        }, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(classDetails.name) + " - " + _toDisplayString(classDetails.id?.subject?.name?.charAt(0)), 1),
                            (index !== learner.previousClasses.length - 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, ","))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(learner.studentNumber), 1),
                  _hoisted_33
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (pageNumber) => {
              return (_openBlock(), _createElementBlock("button", {
                key: pageNumber,
                onClick: ($event: any) => (goToPage(pageNumber)),
                class: _normalizeClass(["!text-gray-600 rounded-sm p-2 text-xs font-medium w-6 h-6 leading-none flex justify-center items-center", { '!text-gray-900': pageNumber === currentPage.value }])
              }, _toDisplayString(pageNumber), 11, _hoisted_35))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_router_link, {
            to: "/main/add-student",
            class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.cancel")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              class: "formkit-input inline-block w-full rounded-lg bg-blue-600 py-2 px-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-base font-semibold leading-normal text-white",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (showConfirmation()))
            }, _toDisplayString(_ctx.$t("archive_flow.complete_assign_learners")), 1)
          ])
        ])
      ]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-xl',
        open: showGenerateEmailModal.value,
        onLocalModalOpen: _cache[10] || (_cache[10] = ($event: any) => (showGenerateEmailModal.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", null, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-question-speech-bubble',
                title: 'rl question speech bubble',
                "aria-hidden": "true"
              }),
              _hoisted_39
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => {
            shouldGenerateEmail.value = false;
          showGenerateEmailModal.value = false;
          showFileUploadModal.value = true;
          }),
                type: "button",
                class: "w-20 rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-blue-600 shadow-sm ring-1 ring-inset ring-blue-600 hover:bg-gray-50"
              }, " Yes "),
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => {
            shouldGenerateEmail.value = true;
          showGenerateEmailModal.value = false;
          showFileUploadModal.value = true;
          }),
                type: "button",
                class: "w-20 rounded-full bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-rl-base-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rl-base-bg-blue-600"
              }, " No ")
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-xl',
        open: showFileUploadModal.value,
        onLocalModalOpen: _cache[12] || (_cache[12] = ($event: any) => (showFileUploadModal.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("h3", _hoisted_43, "Upload new learners to Class " + _toDisplayString(currentClassGroup.value.name), 1),
                (_unref(schoolStore).currentSchool && _unref(schoolStore).currentSchoolStructure)
                  ? (_openBlock(), _createBlock(FileUploadWidgetComponent, {
                      key: 0,
                      schoolStructure: _unref(schoolStore).currentSchoolStructure,
                      classGroupId: currentClassGroup.value._id,
                      shouldGenerateEmail: shouldGenerateEmail.value,
                      schoolData: _unref(schoolStore).currentSchool,
                      subjects: _unref(filterStore).filterOptions?.subjects,
                      validate: true,
                      onCloseUploadModal: _cache[11] || (_cache[11] = ($event: any) => (showFileUploadModal.value = false)),
                      onUploadedLearners: receiveUploadedLearners
                    }, null, 8, ["schoolStructure", "classGroupId", "shouldGenerateEmail", "schoolData", "subjects"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-xl',
        open: showUploadedLearnersModal.value,
        onLocalModalOpen: _cache[13] || (_cache[13] = ($event: any) => (showUploadedLearnersModal.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(licenseStore).license?.products, (product) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: product.title,
                        class: "w-full"
                      }, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("h5", _hoisted_51, _toDisplayString(product.title), 1),
                          _createElementVNode("h5", null, _toDisplayString(product.seatsUsed) + "/" + _toDisplayString(product.maxSeats), 1)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", {
                            class: "bg-blue-600 h-2 rounded-full",
                            style: _normalizeStyle({ width: licenseProgress.value(product) + '%' })
                          }, null, 4)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("table", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("tbody", _hoisted_57, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedLearners.value, (learner, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "rounded-lg",
                        key: index
                      }, [
                        _createElementVNode("td", _hoisted_58, [
                          _createVNode(_unref(UserIcon), { class: "w-5 h-5 text-gray-500" })
                        ]),
                        _createElementVNode("td", _hoisted_59, [
                          _createVNode(_component_FormKit, {
                            type: "text",
                            name: "learnerEmail",
                            modelValue: learner.email,
                            "onUpdate:modelValue": ($event: any) => ((learner.email) = $event),
                            placeholder: "Learner Email",
                            classes: {
                        outer: '',
                        wrapper: 'w-11/12',
                        input:
                          'w-full text-sm border border-gray-500 py-2 h-10 rounded-lg px-4 focus:ring-1 focus:ring-rl-base-blue-500 focus:outline-none focus:ring-opacity-50',
                      },
                            validation: "required|(500)email_exists",
                            "validation-rules": { email_exists: email_exists },
                            "validation-visibility": "live",
                            "validation-messages": {
                        email_exists:
                          'Sorry, that email is taken. Try a different one.',
                      }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"])
                        ]),
                        _createElementVNode("td", _hoisted_60, _toDisplayString(learner.firstName), 1),
                        _createElementVNode("td", _hoisted_61, _toDisplayString(learner.lastName), 1),
                        _createElementVNode("td", _hoisted_62, _toDisplayString(learner.studentNumber), 1),
                        _createElementVNode("td", _hoisted_63, _toDisplayString(learner.password), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("button", {
                onClick: clearLearners,
                type: "button",
                class: "inline-flex items-center gap-x-2 rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-rl-base-pink-500 shadow-sm ring-1 ring-inset ring-rl-base-pink-500 hover:bg-gray-50"
              }, [
                _createVNode(_unref(TrashIcon), {
                  class: "-ml-0.5 h-5 w-5",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" Remove ")
              ]),
              _createElementVNode("button", {
                onClick: submitLearnersForUpload,
                type: "button",
                class: "rounded-full bg-rl-base-blue-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-rl-base-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rl-base-bg-rl-base-blue-500"
              }, " Submit ")
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-xl',
        open: showLearnersBulkUploadProgressModal.value,
        onLocalModalOpen: _cache[15] || (_cache[15] = ($event: any) => (showLearnersBulkUploadProgressModal.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  (bulkUploadLoading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                        _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-rollover-mail',
                    title: 'rl rollover mail',
                    "aria-hidden": "true"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("h3", _hoisted_70, _toDisplayString(bulkUploadLoading.value
                  ? "Sending learners for upload"
                  : "Upload complete"), 1)
              ]),
              _hoisted_71
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("button", {
                type: "button",
                class: "bg-indigo-300 rounded-full px-8 py-2 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (showLearnersBulkUploadProgressModal.value = false))
              }, " Assign existing students "),
              _createVNode(_component_router_link, { to: "/main/add-student" }, {
                default: _withCtx(() => [
                  _hoisted_73
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-xl',
        open: confirmAssignLearnersModal.value,
        onLocalModalOpen: _cache[18] || (_cache[18] = ($event: any) => (confirmAssignLearnersModal.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_75, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-magnifying-glass',
                  title: 'rl magnifying glass',
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("h3", _hoisted_77, _toDisplayString(_ctx.$t("archive_flow.modals.confirm_selection")), 1)
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.$t("archive_flow.modals.youve_selected")) + ":", 1),
                _createElementVNode("p", _hoisted_80, _toDisplayString(selectedLearners.value.length) + " " + _toDisplayString(_ctx.$t("archive_flow.modals.students_move")) + " " + _toDisplayString(currentClassGroup.value?.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (confirmAssignLearnersModal.value = false)),
                type: "button",
                class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full"
              }, _toDisplayString(_ctx.$t("archive_flow.modals.edit")), 1),
              _createElementVNode("button", {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (assignLearners())),
                type: "button",
                class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full"
              }, _toDisplayString(_ctx.$t("archive_flow.modals.correct")), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _createVNode(TutorialModalComponent, {
      show: showModal.value,
      "onUpdate:show": _cache[19] || (_cache[19] = ($event: any) => ((showModal).value = $event))
    }, {
      headerSlot: _withCtx(() => [
        _createTextVNode(" Tutorial ")
      ]),
      descriptionSlot: _withCtx(() => [
        _createTextVNode(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus commodi, suscipit, unde deleniti distinctio qui culpa vero repudiandae eum provident laudantium officia laboriosam harum iste fugit nobis minus, consectetur dolorem. ")
      ]),
      strapiContent: _withCtx(() => [
        _createTextVNode(" Strapi content to go here... ")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})